/**
 * 导出报表
 * @var {String} exportUrl 导出的url
 * @var {Object} exportParams 导出需要的请求参数
 * @var {String} exportFileName 导出的文件名
 */
import blobToFile from '@bike/blob-to-file'

export default {
  data() {
    return {
      exportLoading: false,
    }
  },
  methods: {
    exportData() {
      if (!this.exportUrl) return
      this.exportLoading = true
      this.$message.warning('下载中... 请勿刷新页面！')

      const data = {
        params: this.exportParams,
      }
      if (this.exportUrl !== 'exportReportData') {
        data.responseType = 'blob'
      }

      this.fetch
        .get(this.exportUrl, data)
        .then(res => {
          if (this.exportUrl === 'exportReportData') {
            this.$message.success(res.message)
          } else {
            blobToFile(res, { fileName: this.exportFileName, ext: 'xls' })
            this.$message.success('文件已下载完成！')
          }
        })
        .catch(() => {})
        .finally(() => {
          this.exportLoading = false
        })
    },
  },
}
